(() => {
  document.querySelectorAll('[data-star-video-trigger]').forEach(trigger => {
    const dialog = document.getElementById(trigger.dataset.starVideoTrigger);
    if (!dialog || trigger.dataset.videoReady) return;
    trigger.dataset.videoReady = 'true';
    const video = dialog.querySelector('video');
    trigger.addEventListener('click', () => {
      dialog.showModal();
      video.play().catch(() => {});
    });
    dialog.querySelector('.mi-jose-photo-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      video.pause();
      trigger.focus({ preventScroll: true });
    });
  });
})();
